import { base } from './';
import { IAuthedAdmin } from 'types';

const get = () => base.get<IAuthedAdmin>('/me');

const changePassword = (data: {
  currentPassword: string;
  newPassword: string;
}) => base.patch('/me/password', data);

export { get, changePassword };
